import { Typography } from "@analyticsMD/quil";
import PatientConsideration from "../types/PatientConsideration";
import ReactMarkdown from "react-markdown";

export class PatientConsiderationObj {
  patientConsideration: PatientConsideration;
  constructor(patientConsideration: PatientConsideration) {
    this.patientConsideration = patientConsideration;
  }

  getDescription(): JSX.Element | null {
    const title = this.patientConsideration.consideration_reasoning_title;
    const description =
      this.patientConsideration.consideration_reasoning_description;
    const hasTitle = !!title?.trim();
    const hasDescription = !!description?.trim();

    // No reasoning content → return null so callers suppress the hover tooltip
    // and its dashed-underline affordance. (Previously this always returned a
    // fragment, so `disableHoverListener={!description}` was never true and the
    // tooltip opened an empty box on hover for considerations with no reasoning.)
    if (!hasTitle && !hasDescription) {
      return null;
    }

    return (
      <>
        {hasTitle && (
          <Typography variant="h6" align="left" fontWeight="bold" fontSize={13}>
            {title}
          </Typography>
        )}
        {hasDescription && (
          <Typography variant="body1" align="left" fontSize={11}>
            <ReactMarkdown>{description}</ReactMarkdown>
          </Typography>
        )}
      </>
    );
  }
}
